import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
  createFilterOptions,
  Tab,
} from "@mui/material";
import React, { useEffect, useRef, useState, useCallback } from "react";
import { TabContext, TabList, TabPanel } from "@mui/lab";

import {
  Add,
  Clear,
  DeleteOutline,
  FileUploadOutlined,
  Check,
  Close as CloseIcon,
} from "@mui/icons-material";
import { color } from "../../../StyleData/Config";
import { ErrorMessage, Field, Form, Formik } from "formik";
import {
  getCurrentInTimeZone,
  fromUTC,
  toUTC,
  getDateWithOutUTC,
} from "../../../utils/dateUtil";
import { isFileSizeAllowed } from "../../../utils/fileUploadValidation";
import { masterAPI } from "../../Masters/dataConfig";
import {
  DatePicker,
  DateTimePicker,
  LocalizationProvider,
  renderTimeViewClock,
} from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoItem } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { axiosPrivate } from "../../../axios/axios";
import NormalTable from "../../../Component/NormalTable";
import { toast } from "react-toastify";
import ErrorProps from "../../../Component/Errorprops";
import * as Yup from "yup";
import Loading from "../../../Component/Loading";
import UnifiedModal from "../../../Component/UnifiedModal";
import { defaultInfo, isSystemAccess } from "../../../ConfigInfo/Info";
import { useSelector } from "react-redux";

const ServiceReqModal = ({
  mode,
  handleCloseClick,
  editData,
  approvalContext,
}) => {
  const siteInfoDetail = useSelector((state) => state.auth.loginInfo);
  const isSystem = isSystemAccess(siteInfoDetail);
  const [value, setValue] = useState("1");
  const [loading, setLoading] = useState(false);
  const [problemCode, setProblemCode] = useState([]);
  const [failureClass, setFailureClass] = useState([]);
  const [asset, setAsset] = useState([]);
  const [location, setLocation] = useState([]);
  const [system, setSystem] = useState([]);
  const [workType, setWorkType] = useState([]);
  const [workCenters, setWorkCenters] = useState([]);
  const [storeEMandCMValue, setStoreEMandCMValue] = useState([]);
  const [assetInfo, setAssetInfo] = useState({});
  const [docData, setDocData] = useState([]);
  const [documentValue, setDocumentValue] = useState({
    documentName: "",
    documenttype: "",
    documentcategory: "",
    documentData: "",
  });
  const [type, setType] = useState([]);
  const [workTypeSelect, setWorkTypeSel] = useState(null);
  const [category, setCategory] = useState([]);
  const [fileName, setFileName] = useState("");
  const [fileType, setFileType] = useState("");
  const [srName, setSrName] = useState([]);
  const [approvalStatus, setApprovalStatus] = useState(null);
  const [approvalLevel, setApprovalLevel] = useState(null); // Add this
  const [rejectedDescription, setRejectedDescription] = useState(""); // Add this
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectDescription, setRejectDescription] = useState("");
  const formikRef = useRef();

  useEffect(() => {
    if (mode === "Edit" && editData.workCenterId && workCenters.length > 0) {
      const validId = getValidWorkCenterId(workCenters, editData.workCenterId);
      if (validId && formikRef.current && formikRef.current.values.workCenterId !== validId) {
        formikRef.current.setFieldValue("workCenterId", validId);
      }
    }
  }, [workCenters, editData.workCenterId, mode]);

  const fetchApprovalStatus = useCallback(async () => {
    if (!approvalContext?.approvalId) return;

    const link = masterAPI["workFlowApproval"].link;
    await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        const approvalRecord = res.data.result.find(
          (item) => item.id === approvalContext.approvalId,
        );
        if (approvalRecord) {
          setApprovalStatus(approvalRecord.status);
          setApprovalLevel(approvalRecord.workFlowLevel || null);
          setRejectedDescription(approvalRecord.description || "");
        }
      })
      .catch((e) => {
        console.log(e, "fetch approval status error");
      });
  }, [approvalContext, masterAPI, setApprovalStatus, axiosPrivate]);

  const getDataList = useCallback(async () => {
    setLoading(true);
    getData();
    if (mode === "Edit") {
      const problemLink = masterAPI["problems"].link;
      await axiosPrivate
        .get(`${problemLink}/${editData.failureClassId}`, { offlineCache: { entityType: "problems" } })
        .then((res) => {
          console.log(res, "problemcode");
          setProblemCode(res.data.result);
        })
        .catch((e) => {
          setProblemCode([]);
          console.log(e, "error problem sr");
        });
    }
    const link = masterAPI["failureClass"].link;
    await axiosPrivate
      .get(`${link}`, { offlineCache: { entityType: "failureClass" } })
      .then((res) => {
        setLoading(false);
        setFailureClass(res.data.result);
      })
      .catch((e) => {
        setFailureClass([]);
        console.log(e, "createfailureCodegetAll");
      });

    const typeLink = masterAPI["selectList"].documentType;
    await axiosPrivate
      .get(`${typeLink}`, { offlineCache: { entityType: "documentType" } })
      .then((res) => {
        console.log(res);
        setType(res.data);
      })
      .catch((e) => {
        setType([]);
        console.log(e, "error document type");
      });
    const categoryLink = masterAPI["selectList"].documentcategories;
    await axiosPrivate
      .get(`${categoryLink}`, { offlineCache: { entityType: "documentCategory" } })
      .then((res) => {
        console.log(res);
        setCategory(res.data);
      })
      .catch((e) => {
        setCategory([]);
        console.log(e, "error document category");
      });

    const locLink = masterAPI["location"].link;
    await axiosPrivate
      .get(`${locLink}`, { offlineCache: { entityType: "location" } })
      .then((res) => {
        setLocation(res.data.result);
      })
      .catch((e) => {
        setLocation([]);
        console.log(e, "create location getAll");
      });

    if (isSystem) {
      const sysLink = masterAPI["system"].link;
      await axiosPrivate
        .get(`${sysLink}`, { offlineCache: { entityType: "system" } })
        .then((res) => {
          setSystem(res.data.result.filter((fil) => fil.isActive));
        })
        .catch((e) => {
          setSystem([]);
          console.log(e, "create system getAll");
        });
    }

    const workTypeLink = masterAPI["selectList"].workordertype;
    await axiosPrivate
      .get(`${workTypeLink}`, { offlineCache: { entityType: "workordertype" } })
      .then((res) => {
        const filterEMCM = res.data.filter(
          (val) =>
            val.text.split("-")[0].trim() === defaultInfo.workType.EM ||
            val.text.split("-")[0].trim() === defaultInfo.workType.CM,
        );
        console.log(
          filterEMCM.map((u) => u.value),
          "EMCM",
        );
        setStoreEMandCMValue(filterEMCM.map((u) => u.value));
        setWorkTypeSel(res.data[0].value || null);
        setWorkType(res.data || []);
      })
      .catch((e) => {
        setWorkType([]);
        console.log(e, "worktype");
      });

    const srnamelink = masterAPI["srName"].link;
    await axiosPrivate
      .get(`${srnamelink}`, { offlineCache: { entityType: "srName" } })
      .then((res) => {
        console.log(res.data.result);
        setSrName(res.data.result);
      })
      .catch((e) => {
        console.log(e);
        setSrName([]);
      });

    setLoading(false);

    axiosPrivate
      .get("/selectlist/getallworkcenters", { offlineCache: { entityType: "workCenters" } })
      .then((res) => {
        setWorkCenters(res.data);
      })
      .catch(() => setWorkCenters([]));
  }, [
    mode,
    editData,
    masterAPI,
    setLoading,
    setProblemCode,
    setFailureClass,
    setType,
    setCategory,
    setLocation,
    setWorkTypeSel,
    setWorkType,
    setSrName,
    setWorkCenters,
    axiosPrivate,
  ]);

  const getData = async () => {
    const assetLink = masterAPI["assets"].link;
    await axiosPrivate
      .get(`${assetLink}`, { offlineCache: { entityType: "assets" } })
      .then((res) => {
        const filterDataByAssetStatus = res.data.result.filter(
          (item) =>
            item.statusName !== "Decomissioned" &&
            item.statusName !== "Missing",
        );
        setAsset(filterDataByAssetStatus);
      })
      .catch((e) => {
        setAsset([]);
        console.log(e, "create asset getAll");
      });
  };

  const defaultFilterOptions = createFilterOptions();

  const filterOptions = (options, state) => {
    return defaultFilterOptions(options, state);
  };
  const CustomPaper = (props) => {
    return <Paper elevation={8} {...props} />;
  };

  const handleCancel = () => {
    handleCloseClick();
  };

  useEffect(() => {
    getDataList();
    // Fetch approval status if coming from approval page
    if (approvalContext?.approvalId) {
      fetchApprovalStatus();
    }
  }, [approvalContext?.approvalId, fetchApprovalStatus, getDataList]);

  useEffect(() => {
    if (formikRef.current) {
      const formikCurrent = formikRef.current;
      formikCurrent.setFieldValue(
        "workTypeId",
        formikCurrent.values.workTypeId === null
          ? workTypeSelect
          : formikCurrent.values.workTypeId,
      );
    }
  }, [workTypeSelect]);

  const handleApprove = async () => {
    if (!approvalContext?.approvalId) return;

    const updateLink = masterAPI["workFlowApproval"].update;
    const payload = {
      id: approvalContext.approvalId,
      status: "Approved",
    };

    await axiosPrivate
      .put(`${updateLink}`, payload)
      .then((res) => {
        console.log(res.data);
        setApprovalStatus("Approved");
        // toast.success("Request approved successfully");
        // Don't close modal immediately, let user see the status change
        setTimeout(() => {
          handleCloseClick();
        }, 1500);
      })
      .catch((e) => {
        console.log(e, "approve error");
        // toast.error(
        //   e.response?.data?.failureMessage || "Failed to approve request",
        // );
      });
  };

  const handleReject = async () => {
    if (!approvalContext?.approvalId) return;
    if (!rejectDescription.trim()) {
      toast.error("Description is required to reject.");
      return;
    }
    const updateLink = masterAPI["workFlowApproval"].update;
    const payload = {
      id: approvalContext.approvalId,
      status: "Rejected",
      description: rejectDescription,
    };
    await axiosPrivate
      .put(`${updateLink}`, payload)
      .then(() => {
        setApprovalStatus("Rejected");
        // toast.success("Request rejected successfully");
        setShowRejectModal(false);
        setRejectDescription("");
        setTimeout(() => {
          handleCloseClick();
        }, 1500);
      })
      .catch((e) => {
        // toast.error(
        //   e.response?.data?.failureMessage || "Failed to reject request",
        // );
      });
  };

  const handleFailureProblem = async (fcid) => {
    const pcLink = masterAPI["problems"].problembyFailureClass;
    await axiosPrivate
      .get(`${pcLink}/${fcid}`, { offlineCache: { entityType: "problems" } })
      .then((res) => {
        console.log(res.data.result);
        setProblemCode(res.data.result);
      })
      .catch((e) => {
        setProblemCode([]);
        console.log(e, "Problem Create Wo");
      });
  };

  const getValidWorkCenterId = (workCenters, initialId) => {
    const validCenters = workCenters.filter(
      (center) => center.value && String(center.text).toLowerCase() !== "none",
    );
    if (validCenters.some((center) => center.value === initialId)) {
      return initialId;
    }
    return null;
  };

  const initialValue = {
    serviceRequestNameId:
      mode === "Edit" ? editData.serviceRequestNameId : null,
    problemId: mode === "Edit" ? editData.problemId : null,
    failureClassId: mode === "Edit" ? editData.failureClassId : null,
    locationId: mode === "Edit" ? editData.locationId : "",
    systemId: mode === "Edit" ? editData.systemId : null,
    assetId: mode === "Edit" ? editData.assetId : null,
    assetName: mode === "Edit" ? editData.assetName : "",
    serviceRequestName: mode === "Edit" ? editData.serviceRequestName : "",
    description: mode === "Edit" ? editData.description : "",
    reasontoCancel: mode === "Edit" ? editData.reasontoCancel : "",
    // workTypeId:
    //   mode === "Edit"
    //     ? editData.workTypeId
    //     : "d707dbff-d08f-42a8-afa1-12b2e48c266c",
    workTypeId: mode === "Edit" ? editData.workTypeId : null,

    requestedDate:
      mode === "Edit"
        ? (editData.requestedDate!==""&&editData.requestedDate!==undefined&&editData.requestedDate!==null)
          ? fromUTC(editData.requestedDate).dayjsObject
          : getCurrentInTimeZone().dayjsObject
        : getCurrentInTimeZone().dayjsObject,
    stopBeginDate:
      mode === "Edit"
        ? (editData.stopBeginDate!==""&&editData.stopBeginDate!==undefined&&editData.stopBeginDate!==null)
          ? fromUTC(editData.stopBeginDate).dayjsObject
          : getCurrentInTimeZone().dayjsObject
        : getCurrentInTimeZone().dayjsObject,
    closingDate:
      mode === "Edit"
        ? (editData.closingDate!==""&&editData.closingDate!==undefined&&editData.closingDate!==null)
          ? fromUTC(editData.closingDate).dayjsObject
          : getCurrentInTimeZone().dayjsObject
        : getCurrentInTimeZone().dayjsObject,
    approvalDate: mode === "Edit" ? (editData.approvalDate!==""&&editData.approvalDate!==undefined&&editData.approvalDate!==null)
      ? fromUTC(editData.approvalDate).dayjsObject
      : null
      : null,
    workCenterId: getValidWorkCenterId(
      workCenters,
      mode === "Edit" ? editData.workCenterId : "",
    ),
  };
  const validationSchema = Yup.object().shape({
    serviceRequestName: Yup.string().required("Name is required"),
    locationId: Yup.string().required("Location is required"),
    workTypeId: Yup.string().required("Work Type is required"),
    stopBeginDate: Yup.date().when("workTypeId", {
      is: (val) => storeEMandCMValue.includes(val),
      then: (schema) => schema.required("This is required"),
      otherwise: (schema) => schema.notRequired(),
    }),
    // stopBeginDate:Yup.date()
    // .when("workTypeId", {
    //     is: (val) =>["1be60632-241b-4aea-ba31-16e94a8d8c52"].includes(val),
    //     then: (schema) => schema.required("This field is required"),
    //     otherwise: (schema) => schema.notRequired(),
    // }),
    //   assetId: Yup.string().nullable().test(
    //   "asset-or-location",
    //   "Select either Asset or Location",
    //   function (value) {
    //     const { location } = this.parent;
    //     return !!value || !!location;
    //   }
    // ),

    // locationId: Yup.string().nullable().test(
    //   "asset-or-location",
    //   "Select either Asset or Location",
    //   function (value) {
    //     const { asset } = this.parent;
    //     return !!value || !!asset;
    //   }
    // ),
  });
  const onSubmit = async (value) => {
    console.log(value);
    setLoading(true);
    const createLink = masterAPI["serviceRequest"].create;
    const updateLink = masterAPI["serviceRequest"].update;

    const convertedValues = {
      ...value,
      requestedDate: value.requestedDate
        ? toUTC(value.requestedDate).utcISOString
        : value.requestedDate,
      stopBeginDate: value.stopBeginDate
        ? toUTC(value.stopBeginDate).utcISOString
        : value.stopBeginDate,
      closingDate: value.closingDate
        ? toUTC(value.closingDate).utcISOString
        : value.closingDate,
    };

    if (mode === "Create") {
      const postData = {
        ...convertedValues,
        serviceRequestDocumentsList: docData,
      };
      console.log("Payload for Create:", postData);
      const selectedAsset = asset.find((a) => a.id === value.assetId);
      const selectedLocation = location.find((l) => l.id === value.locationId);
      await axiosPrivate
        .post(`${createLink}`, postData, {
          offlineQueue: {
            entityType: "serviceRequest",
            optimisticResult: { message: "" },
            displayRow: {
              code: "Pending",
              serviceRequestName: value.serviceRequestName,
              assetName: selectedAsset?.assetName || "",
              locationName: selectedLocation?.locationName || "",
              status: "Pending Sync",
              isActive: true,
            },
          },
        })
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          if (res.__offlineQueued) {
            toast.info("Saved offline — will sync when you're back online.");
          }
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          // toast.error(e.response.data.failureMessage);
          console.log(e, "create serviceRequest");
        });
    } else {
      const updateAC = {
        id: editData.id,
        serviceRequestDocumentsList: docData,
        ...convertedValues,
      };
      await axiosPrivate
        .put(`${updateLink}`, updateAC, {
          offlineQueue: {
            entityType: "serviceRequest",
            optimisticResult: { message: "" },
          },
        })
        .then((res) => {
          console.log(res.data);
          setLoading(false);
          if (res.__offlineQueued) {
            toast.info("Saved offline — will sync when you're back online.");
          }
          handleCloseClick();
        })
        .catch((e) => {
          setLoading(false);
          // toast.error(e.response.data.failureMessage);
          console.log(e, "update serviceRequest");
        });
    }
  };

  const handleTab = (e, newValue) => {
    setValue(newValue);
  };

  const handleUpload = () => {
    console.log(documentValue);
    setDocData([
      ...docData,
      {
        ...documentValue,
        documentName: `${documentValue.documentName}.${fileType}`,
      },
    ]);
    setDocumentValue({
      documentName: "",
      documenttype: "",
      documentcategory: "",
      documentData: "",
    });
    setFileName("");
    setFileType("");
  };

  const handleDelete = (del) => {
    const filterData = docData.filter((fill, i) => i !== Number(del.row.id));
    setDocData(filterData);
  };

  const columns = [
    // {
    //   Header: "Doc ID",
    //   accessor: "id",
    //   Cell: ({ cell }) => {
    //     return (
    //       <Typography
    //         sx={{ fontSize: "inherit", fontWeight: "inherit", color: "blue" }}
    //       >
    //         {cell.value}
    //       </Typography>
    //     );
    //   },
    // },
    {
      Header: "Doc Name",
      accessor: "documentName",
      Cell: ({ cell }) => {
        return (
          <Typography
            sx={{ fontSize: "inherit", fontWeight: "inherit" }}
            // onClick={()=>{handleDownload(cell.row.original.id)}}
          >
            {cell.value}
          </Typography>
        );
      },
    },
    {
      Header: "Doc Type",
      accessor: "documenttype",
    },
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        // console.log(cell)
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton
              onClick={() => {
                handleDelete(cell);
              }}
            >
              <DeleteOutline
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: color.masterEditDelButtonColor,
                }}
              />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box sx={{ p: color.masterPageDialogPadding }}>
          <Formik
            innerRef={formikRef}
            initialValues={initialValue}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ handleChange, setFieldValue, values }) => (
              <Form>
                <TabContext value={value}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <TabList
                      onChange={handleTab}
                      aria-label="lab API tabs example"
                    >
                      <Tab
                        label={mode !== "Create" ? "Update" : "Create"}
                        value="1"
                      />
                      <Tab label="Document" value="2" />
                    </TabList>

                    <IconButton onClick={handleCancel}>
                      <Clear />
                    </IconButton>
                  </Box>
                  {/* <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)"}} /> */}
                  <TabPanel value="1" sx={{ p: 0, pt: 1 }}>
                    <Grid container spacing={"1rem"}>
                      <Grid item xs={12}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                        >
                          <Typography
                            sx={{
                              color: color.masterDialogTitleColor,
                              fontSize: color.masterDialogFontSize,
                            }}
                          >
                            {mode === "Edit"
                              ? editData.code +
                                "-" +
                                editData.serviceRequestName
                              : "New Service Request"}
                          </Typography>
                        </Box>
                        <Divider
                          sx={{
                            border: "1px solid rgb(0 0 0 / 17%)",
                            mb: "15px",
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Service Request Name
                        </Typography>
                        {/* <Field
                  as={TextField}
                  size={"small"}
                  type="text"
                
                  name="serviceRequestName"
                  placeholder="Enter Service Request Name"
                  fullWidth
                  sx={{
                    ".MuiInputBase-input": {
                      // letterSpacing: "0.2rem",

                      "&::placeholder": {
                        // color: "green",
                        opacity: 1,
                        color: color.placeholderColor,
                        fontSize: "13px",
                      },
                    },
                  }}
                /> */}

                        <Field
                          name="serviceRequestName"
                          value={
                            srName.find(
                              (sr) => sr.id === values.serviceRequestNameId,
                            ) || null
                          }
                          inputValue={values.serviceRequestName || ""}
                          component={Autocomplete}
                          filterOptions={filterOptions}
                          loading={srName.length === 0}
                          options={srName}
                          freeSolo
                          autoSelect
                          PaperComponent={CustomPaper}
                          getOptionLabel={(option) =>
                            typeof option === "string"
                              ? option
                              : option
                                ? option.name
                                : ""
                          }
                          onChange={(event, value) => {
                            if (value && typeof value === "object") {
                              setFieldValue("serviceRequestNameId", value.id);
                              setFieldValue("serviceRequestName", value.name);
                            } else {
                              // typed name with no matching option - allow it as a custom entry
                              setFieldValue("serviceRequestNameId", null);
                              setFieldValue(
                                "serviceRequestName",
                                typeof value === "string" ? value : "",
                              );
                            }
                          }}
                          onInputChange={(event, newInputValue, reason) => {
                            if (reason === "input") {
                              setFieldValue("serviceRequestName", newInputValue);
                              setFieldValue("serviceRequestNameId", null);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="serviceRequestName"
                              placeholder="Search or Enter Service Request Name"
                              onChange={handleChange}
                              // variant="standard"
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                // endAdornment: (
                                //   <React.Fragment>
                                //     {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                                //     {srName.length === 0 ? (
                                //       <CircularProgress color="inherit" size={20} />
                                //     ) : null}
                                //     {params.InputProps.endAdornment}
                                //   </React.Fragment>
                                // ),
                                endAdornment: (
                                  <>{params.InputProps.endAdornment}</>
                                ),
                              }}
                            />
                          )}
                        >
                          {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                        </Field>
                        <ErrorMessage name="serviceRequestName">
                          {(error) => <ErrorProps>{error}</ErrorProps>}
                        </ErrorMessage>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Description
                        </Typography>
                        <Field
                          as={TextField}
                          size={"small"}
                          type="text"
                          name="description"
                          placeholder="Enter Description"
                          fullWidth
                          sx={{
                            ".MuiInputBase-input": {
                              // letterSpacing: "0.2rem",

                              "&::placeholder": {
                                // color: "green",
                                opacity: 1,
                                color: color.placeholderColor,
                                fontSize: "13px",
                              },
                            },
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Asset
                        </Typography>
                        {/* <Field
                  as={Select}
                  // label={"Select"}
                  size={"small"}
                  type="text"
                  name="assetId"
                  fullWidth
                  displayEmpty
                  MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                  renderValue={
                    values.assetId !== ""
                      ? undefined
                      : () => (
                          <Typography
                            sx={{
                              color: color.placeholderColor,
                              fontSize: "13px",
                            }}
                          >
                            Select
                          </Typography>
                        )
                  }
                >
                  {asset.map((id, i) => (
                    <MenuItem value={id.id}>{id.assetName}</MenuItem>
                  ))}
                </Field> */}

                        <Field
                          name="assetId"
                          value={
                            asset.find((a) => a.id === values.assetId) || null
                          }
                          component={Autocomplete}
                          filterOptions={filterOptions}
                          loading={asset.length === 0}
                          options={asset}
                          PaperComponent={CustomPaper}
                          getOptionLabel={(option) =>
                            option ? option.code + " - " + option.assetName : ""
                          }
                          onChange={(event, value) => {
                            if (value) {
                              console.log(value);
                              setFieldValue("assetId", value.id);
                              setFieldValue("locationId", value.locationId);
                              setFieldValue("systemId", value.systemId || null);
                              setFieldValue(
                                "failureClassId",
                                value.failureClassesId,
                              );
                              setAssetInfo(value);
                              handleFailureProblem(value.failureClassesId);
                            } else {
                              setFieldValue("assetId", null);
                              setFieldValue("locationId", null);
                              setFieldValue("systemId", null);
                              setAssetInfo({});
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="assetId"
                              placeholder="Search Asset"
                              onChange={handleChange}
                              // variant="standard"
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                // endAdornment: (
                                //   <React.Fragment>
                                //     {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                                //     {asset.length === 0 ? (
                                //       <CircularProgress color="inherit" size={20} />
                                //     ) : null}
                                //     {params.InputProps.endAdornment}
                                //   </React.Fragment>
                                // ),
                                endAdornment: (
                                  <>{params.InputProps.endAdornment}</>
                                ),
                              }}
                            />
                          )}
                        >
                          {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                        </Field>
                        {/* <ErrorMessage name="assetId">
                                                    {(error) => <ErrorProps>{error}</ErrorProps>}
                                                  </ErrorMessage> */}
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Location
                        </Typography>
                        {/* <Field
                  as={Select}
                  // label={"Select"}
                  size={"small"}
                  type="text"
                  name="locationId"
                  fullWidth
                  displayEmpty
                  MenuProps={{ PaperProps: { sx: { maxHeight: "40vh" } } }}
                  renderValue={
                    values.locationId !== ""
                      ? undefined
                      : () => (
                          <Typography
                            sx={{
                              color: color.placeholderColor,
                              fontSize: "13px",
                            }}
                          >
                            Select
                          </Typography>
                        )
                  }
                >
                  {location.map((id, i) => (
                    <MenuItem value={id.id}>{id.locationCode+" - "+id.locationName}</MenuItem>
                  ))}
                </Field> */}
                        <Field
                          name="locationId"
                          value={
                            location.find(
                              (loc) => loc.id === values.locationId,
                            ) || null
                          }
                          readOnly={!!assetInfo?.locationId}
                          component={Autocomplete}
                          filterOptions={filterOptions}
                          loading={location.length === 0}
                          options={location}
                          PaperComponent={CustomPaper}
                          getOptionLabel={(option) =>
                            option ? option.code + " - " + option.locationName : ""
                          }
                          onChange={async (event, value) => {
                            if (value) {
                              console.log(value);
                              const assetByLocation =
                                masterAPI["assets"].assetByLocation;
                              await axiosPrivate
                                .get(`${assetByLocation}/${value.id}`)
                                .then((res) => {
                                  setAsset(res.data.result);
                                })
                                .catch((e) => {
                                  setAsset([]);
                                  console.log(e, "error");
                                });
                              setFieldValue("locationId", value.id);
                              setFieldValue("assetId", null);
                              setFieldValue("systemId", null);
                              setAssetInfo({});
                            } else {
                              setFieldValue("locationId", null);
                              setFieldValue("assetId", null);
                              getData();
                              setAssetInfo({});
                              // setFieldValue("failureClassId",null)
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="locationId"
                              placeholder="Search location"
                              onChange={handleChange}
                              size="small"
                              // variant="standard"

                              InputProps={{
                                ...params.InputProps,
                                // endAdornment: (
                                //   <React.Fragment>
                                //     {/* {info.length === 0 ? <CircularProgress color="inherit" size={20} /> : null} */}
                                //     {location.length === 0 ? (
                                //       <CircularProgress color="inherit" size={20} />
                                //     ) : null}
                                //     {params.InputProps.endAdornment}
                                //   </React.Fragment>
                                // ),
                                endAdornment: (
                                  <>{params.InputProps.endAdornment}</>
                                ),
                              }}
                            />
                          )}
                        >
                          {/* {userData.map((typeId, i) => (
                          <MenuItem value={typeId.userId} key={i}>
                            {typeId.userName}
                          </MenuItem>
                        ))} */}
                        </Field>
                        <ErrorMessage name="locationId">
                          {(error) => <ErrorProps>{error}</ErrorProps>}
                        </ErrorMessage>
                      </Grid>
                      {isSystem && (
                        <Grid item xs={12} md={6}>
                          <Typography
                            sx={{
                              fontWeight: color.labelFontWeight,
                              mb: color.labelmb,
                              fontSize: color.labelFont,
                              color: color.labelColor,
                            }}
                          >
                            System
                          </Typography>
                          <Field
                            name="systemId"
                            value={
                              system.find(
                                (sys) => sys.id === values.systemId,
                              ) || null
                            }
                            readOnly={!!assetInfo?.systemId}
                            component={Autocomplete}
                            filterOptions={filterOptions}
                            loading={system.length === 0}
                            options={system}
                            PaperComponent={CustomPaper}
                            getOptionLabel={(option) =>
                              option ? option.systemCode + " - " + option.systemName : ""
                            }
                            onChange={async (event, value) => {
                              if (value) {
                                console.log(value);
                                const assetBySystem =
                                  masterAPI["assets"].assetBySystem;
                                await axiosPrivate
                                  .get(`${assetBySystem}/${value.id}`)
                                  .then((res) => {
                                    setAsset(res.data.result);
                                  })
                                  .catch((e) => {
                                    setAsset([]);
                                    console.log(e, "error");
                                  });
                                setFieldValue("systemId", value.id);
                                setFieldValue("assetId", null);
                                setFieldValue("locationId", null);
                                setAssetInfo({});
                              } else {
                                setFieldValue("systemId", null);
                                setFieldValue("assetId", null);
                                getData();
                                setAssetInfo({});
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                name="systemId"
                                placeholder="Search System"
                                onChange={handleChange}
                                size="small"
                                InputProps={{
                                  ...params.InputProps,
                                  endAdornment: (
                                    <>{params.InputProps.endAdornment}</>
                                  ),
                                }}
                              />
                            )}
                          />
                        </Grid>
                      )}
                      <Grid item xs={12} md={6}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Work Type
                        </Typography>
                        <Field
                          as={Select}
                          // label={"Select"}
                          size={"small"}
                          type="text"
                          name="workTypeId"
                          fullWidth
                          displayEmpty
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: "40vh" } },
                          }}
                          renderValue={
                            values.workTypeId !== ""
                              ? undefined
                              : () => (
                                  <Typography
                                    sx={{
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    }}
                                  >
                                    Select
                                  </Typography>
                                )
                          }
                        >
                          {workType.map((type) => (
                            <MenuItem
                              key={type.value}
                              value={type.value}
                              // onClick={()=>{setSelWT((type.text.split("-")[0]).trim())}}
                              sx={{
                                display:
                                  type.text.toUpperCase() === "PM"
                                    ? "none"
                                    : "default",
                              }}
                            >
                              {type.text}
                            </MenuItem>
                          ))}
                        </Field>
                        <ErrorMessage name="workTypeId">
                          {(error) => <ErrorProps>{error}</ErrorProps>}
                        </ErrorMessage>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Work Center
                        </Typography>
                        <Autocomplete
                          name="workCenterId"
                          value={
                            workCenters
                              .filter(
                                (center) =>
                                  center.value &&
                                  String(center.text).toLowerCase() !== "none",
                              )
                              .find(
                                (center) =>
                                  center.value === values.workCenterId,
                              ) || null
                          }
                          filterOptions={filterOptions}
                          loading={workCenters.length === 0}
                          options={workCenters.filter(
                            (center) =>
                              center.value &&
                              String(center.text).toLowerCase() !== "none",
                          )}
                          PaperComponent={CustomPaper}
                          getOptionLabel={(option) => option?.text || ""}
                          isOptionEqualToValue={(option, value) =>
                            option?.value === value?.value
                          }
                          onChange={(event, value) => {
                            if (value && typeof value === "object") {
                              setFieldValue("workCenterId", value.value);
                            } else {
                              setFieldValue("workCenterId", null);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="workCenterId"
                              placeholder="Search Work Center"
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                  <>{params.InputProps.endAdornment}</>
                                ),
                              }}
                            />
                          )}
                        />
                        <ErrorMessage name="workCenterId">
                          {(error) => <ErrorProps>{error}</ErrorProps>}
                        </ErrorMessage>
                      </Grid>{" "}
                      <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{ ".css-1xhypcz-MuiStack-root": { paddingTop: 0 } }}
                      >
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            // mb: color.labelmb,
                            fontSize: color.masterFontSize,
                            color: color.labelColor,
                          }}
                        >
                          Requested Date
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoItem>
                            <DatePicker
                              format="DD/MM/YYYY HH:mm"
                              value={dayjs(values.requestedDate)}
                              //   sx={{".css-1xhypcz-MuiStack-root":{
                              //     padding:0
                              //   }}}
                              readOnly
                              slotProps={{
                                textField: {
                                  size: "small",
                                  margin: "-8px 0 0 0",
                                  fullWidth: true,
                                },
                              }}
                              onChange={(newValue) => {
                                console.log(newValue);
                                if (newValue !== null) {
                                  if (`${newValue.$d}` !== "Invalid Date") {
                                    const dateFrom =
                                      getDateWithOutUTC(newValue);
                                    // const hour =
                                    //   new Date().getHours() < 10
                                    //     ? "0" + new Date().getHours()
                                    //     : new Date().getHours();
                                    // const min =
                                    //   new Date().getMinutes() < 10
                                    //     ? "0" + new Date().getMinutes()
                                    //     : new Date().getMinutes();
                                    // const sec =
                                    //   new Date().getSeconds() < 10
                                    //     ? "0" + new Date().getSeconds()
                                    //     : new Date().getSeconds();
                                    // const dateFormat =
                                    //   dateFrom + "T" + hour + ":" + min + ":" + sec;
                                    setFieldValue("requestedDate", dateFrom);
                                  }
                                }
                              }}
                            />
                          </DemoItem>
                        </LocalizationProvider>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Failure Class
                        </Typography>
                        <Field
                          as={Select}
                          // label={"Select"}
                          size={"small"}
                          type="text"
                          name="failureClassId"
                          readOnly
                          IconComponent={() => null}
                          // readOnly={
                          //   assetInfo.failureClassesId !== undefined &&
                          //   assetInfo.failureClassesId !== null
                          // }
                          fullWidth
                          onChange={async (e) => {
                            console.log(e.target.value);
                            const codeLink = masterAPI["problems"].link;
                            await axiosPrivate
                              .get(`${codeLink}/${e.target.value}`)
                              .then((res) => {
                                setLoading(false);
                                setProblemCode(res.data.result);
                              })
                              .catch((e) => {
                                console.log(e, " problem service req");
                              });
                            setFieldValue("failureClassId", e.target.value);
                          }}
                          displayEmpty
                          MenuProps={{
                            PaperProps: { sx: { maxHeight: "40vh" } },
                          }}
                          renderValue={
                            values.failureClassId !== null
                              ? undefined
                              : () => (
                                  <Typography
                                    sx={{
                                      color: color.placeholderColor,
                                      fontSize: "13px",
                                    }}
                                  ></Typography>
                                )
                          }
                        >
                          {failureClass.map((id) => (
                            <MenuItem value={id.id}>
                              {id.code + " - " + id.failureClassName}
                            </MenuItem>
                          ))}
                        </Field>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Problem Code
                        </Typography>

                        <Field
                          name="problemId"
                          component={Autocomplete}
                          filterOptions={filterOptions}
                          loading={problemCode.length === 0}
                          options={problemCode}
                          PaperComponent={CustomPaper}
                          getOptionLabel={(option) =>
                            option?.code
                              ? option.code + " - " + option.problemName
                              : ""
                          }
                          value={
                            problemCode.find(
                              (x) => x.id === values.problemId,
                            ) || null
                          }
                          onChange={(event, value) => {
                            if (value) {
                              setFieldValue("problemId", value.id);
                            } else {
                              setFieldValue("problemId", null);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Search problem code"
                              size="small"
                              InputProps={{
                                ...params.InputProps,
                                readOnly:
                                  assetInfo.problemId !== undefined &&
                                  assetInfo.problemId !== null,
                                endAdornment: (
                                  <>{params.InputProps.endAdornment}</>
                                ),
                              }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={6}
                        sx={{ ".css-1xhypcz-MuiStack-root": { paddingTop: 0 } }}
                      >
                        <Typography
                          sx={{
                            fontWeight: color.labelFontWeight,
                            mb: color.labelmb,
                            fontSize: color.labelFont,
                            color: color.labelColor,
                          }}
                        >
                          Stop Begin Date
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoItem>
                           <DateTimePicker
                            format="DD/MM/YYYY HH:mm"
                            value={
                              values.stopBeginDate
                                ? dayjs(values.stopBeginDate)
                                : null
                            }
                            ampm={false}
                            viewRenderers={{
                              hours: renderTimeViewClock,
                              minutes: renderTimeViewClock,
                              seconds: renderTimeViewClock,
                            }}
                            maxDateTime={getCurrentInTimeZone().dayjsObject}
                            slotProps={{
                              textField: {
                                size: "small",
                                fullWidth: true,
                              },
                            }}
                            fullWidth
                            onChange={(newValue) => {
                              if (newValue && newValue.isValid()) {
                                const dateFrom = getDateWithOutUTC(newValue);
                                setFieldValue("stopBeginDate", dateFrom);
                              } else {
                                setFieldValue("stopBeginDate", null);
                              }
                            }}
                          />
                          </DemoItem>
                        </LocalizationProvider>
                        <ErrorMessage name="stopBeginDate">
                          {(error) => <ErrorProps>{error}</ErrorProps>}
                        </ErrorMessage>
                      </Grid>
                      {/* <Grid
                item
                xs={12}
                md={6}
                sx={{ ".css-1xhypcz-MuiStack-root": { paddingTop: 0 } }}
              >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    // mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Closing Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                    <DatePicker
                      format="DD/MM/YYYY"
                      value={dayjs(values.closingDate)}
                      //   sx={{".css-1xhypcz-MuiStack-root":{
                      //     padding:0
                      //   }}}
                      slotProps={{
                        textField: { size: "small", margin: "-8px 0 0 0",fullWidth:true },
                      }}
                      onChange={(newValue) => {
                        console.log(newValue);
                        if (newValue !== null) {
                          if (`${newValue.$d}` !== "Invalid Date") {
                            const dateFrom = getDateWithOutUTC(newValue);
                            const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                            const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                            const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                            const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                            setFieldValue("closingDate", dateFormat);
                          }
                        }
                      }}
                    />
                  </DemoItem>
                </LocalizationProvider>
              </Grid>
              <Grid
                item
                xs={12}
                md={6}
                sx={{ ".css-1xhypcz-MuiStack-root": { paddingTop: 0 } }}
              >
                <Typography
                  sx={{
                    fontWeight: color.labelFontWeight,
                    // mb: color.labelmb,
                    fontSize: color.labelFont,
                    color: color.labelColor,
                  }}
                >
                  Approval Date
                </Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoItem>
                    <DatePicker
                      format="DD/MM/YYYY"
                      value={values.approvalDate===null?values.approvalDate:dayjs(values.approvalDate)}
                      //   sx={{".css-1xhypcz-MuiStack-root":{
                      //     padding:0
                      //   }}}
                      slotProps={{
                        textField: { size: "small", margin: "-8px 0 0 0",fullWidth:true },
                      }}
                      onChange={(newValue) => {
                        console.log(newValue);
                        if (newValue !== null) {
                          if (`${newValue.$d}` !== "Invalid Date") {
                            const dateFrom = getDateWithOutUTC(newValue);
                            const hour=(new Date().getHours())<10?"0"+new Date().getHours():new Date().getHours()
                            const min=(new Date().getMinutes())<10?"0"+new Date().getMinutes():new Date().getMinutes()
                            const sec=(new Date().getSeconds())<10?"0"+new Date().getSeconds():new Date().getSeconds()
                            const dateFormat=dateFrom+"T"+hour+":"+min+":"+sec
                            setFieldValue("approvalDate", dateFormat);
                          }
                        }
                      }}
                    />
                  </DemoItem>
                </LocalizationProvider>
              </Grid> */}
                    </Grid>
                  </TabPanel>
                  <TabPanel value="2" sx={{ p: 0, pt: 1 }}>
                    <Box
                      sx={{
                        p: 1,
                        display: "flex",
                        flexDirection: "column",
                        gap: "1rem",
                      }}
                    >
                      <Paper elevation={3} sx={{ p: 1 }}>
                        <Grid container spacing={"1.5rem"}>
                          <Grid item xs={12}>
                            <Box
                              sx={{
                                display: "flex",
                                width: "100%",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography
                                sx={{
                                  color: color.masterDialogTitleColor,
                                  fontSize: color.masterDialogFontSize,
                                }}
                              >
                                Document Upload
                              </Typography>
                              <Box>
                                <IconButton
                                  disabled={fileName === ""}
                                  onClick={handleUpload}
                                >
                                  <Add
                                    sx={{
                                      color:
                                        fileName === "" ? "default" : "#2362B4",
                                    }}
                                  />
                                </IconButton>
                              </Box>
                            </Box>

                            <Divider
                              sx={{
                                border: "1px solid rgb(0 0 0 / 17%)",
                                //   mb: "15px",
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Document Name
                            </Typography>
                            <TextField
                              size={"small"}
                              type="text"
                              name="documentName"
                              value={documentValue.documentName}
                              placeholder="Enter Doc Name"
                              onChange={(e) => {
                                setDocumentValue({
                                  ...documentValue,
                                  [e.target.name]: e.target.value,
                                });
                              }}
                              fullWidth
                              sx={{
                                ".MuiInputBase-input": {
                                  // letterSpacing: "0.2rem",

                                  "&::placeholder": {
                                    // color: "green",
                                    opacity: 1,
                                    color: color.placeholderColor,
                                    fontSize: "13px",
                                  },
                                },
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Document Type
                            </Typography>
                            <Select
                              // label={"Select"}
                              size={"small"}
                              type="text"
                              name="documenttype"
                              value={documentValue.documenttype}
                              fullWidth
                              displayEmpty
                              onChange={(e) => {
                                setDocumentValue({
                                  ...documentValue,
                                  [e.target.name]: e.target.value,
                                });
                              }}
                              MenuProps={{
                                PaperProps: { sx: { maxHeight: "40vh" } },
                              }}
                              renderValue={
                                documentValue.documenttype !== ""
                                  ? undefined
                                  : () => (
                                      <Typography
                                        sx={{
                                          color: color.placeholderColor,
                                          fontSize: "13px",
                                        }}
                                      >
                                        Select
                                      </Typography>
                                    )
                              }
                            >
                              {type.map((id) => (
                                <MenuItem value={id.value}>{id.text}</MenuItem>
                              ))}
                            </Select>
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Document Category
                            </Typography>
                            <Field
                              as={Select}
                              // label={"Select"}
                              size={"small"}
                              type="text"
                              name="documentcategory"
                              value={documentValue.documentcategory}
                              onChange={(e) => {
                                setDocumentValue({
                                  ...documentValue,
                                  [e.target.name]: e.target.value,
                                });
                              }}
                              fullWidth
                              displayEmpty
                              MenuProps={{
                                PaperProps: { sx: { maxHeight: "40vh" } },
                              }}
                              renderValue={
                                documentValue.documentcategory !== ""
                                  ? undefined
                                  : () => (
                                      <Typography
                                        sx={{
                                          color: color.placeholderColor,
                                          fontSize: "13px",
                                        }}
                                      >
                                        Select
                                      </Typography>
                                    )
                              }
                            >
                              {category.map((id) => (
                                <MenuItem value={id.value}>{id.text}</MenuItem>
                              ))}
                            </Field>
                          </Grid>

                          <Grid item xs={12} md={6}>
                            <Typography
                              sx={{
                                fontWeight: color.labelFontWeight,
                                mb: color.labelmb,
                                fontSize: color.labelFont,
                                color: color.labelColor,
                              }}
                            >
                              Document File
                            </Typography>
                            <Button component="label" variant="contained">
                              <FileUploadOutlined />{" "}
                              <Typography sx={{ fontSize: "0.9rem" }}>
                                Add File
                              </Typography>
                              <input
                                type="file"
                                // accept={"image/png, image/gif, image/jpeg"}
                                hidden
                                onChange={(e) => {
                                  console.log(e.target.files[0]);
                                  if (e.target.files[0] !== undefined) {
                                    const file = e.target.files[0];
                                    if (!isFileSizeAllowed(file)) {
                                      e.target.value = "";
                                      return;
                                    }
                                    console.log(file.name);
                                    const fileType = file.type.split("/")[1];
                                    console.log(fileType);
                                    // if (!file.name.toLowerCase().match(/\.(jpg|jpeg|png|gif)$/)) {

                                    //   toast.error("Invalid format");
                                    // } else {
                                    let reader = new FileReader();
                                    reader.readAsDataURL(file);
                                    reader.onload = function () {
                                      // console.log(reader.result);
                                      const dataSplit =
                                        reader.result.split("base64,")[1];
                                      // console.log(dataSplit)
                                      setFileName(file.name);
                                      setFileType(
                                        e.target.files[0].type.split("/")[1],
                                      );

                                      setDocumentValue({
                                        ...documentValue,
                                        documentData: dataSplit,
                                      });
                                    };
                                    reader.onerror = function (error) {};
                                    // }
                                  } else {
                                    setFileName("");
                                    setDocumentValue({
                                      ...documentValue,
                                      documentData: "",
                                    });
                                  }
                                }}
                              />
                            </Button>
                            <Typography
                              sx={{
                                // mb: color.labelmb,

                                fontSize: color.labelFont,
                                // color: color.labelColor,
                              }}
                            >
                              {fileName}
                            </Typography>
                          </Grid>

                          {/* <Grid container item xs={12} justifyContent={"flex-end"}>
                      <Button
                        onClick={() => {
                         handleClose()
                        }}
                      >
                        cancel
                      </Button>
                      <Button type="submit">submit</Button>
                    </Grid> */}
                        </Grid>
                      </Paper>
                      <Paper
                        elevation={3}
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                          p: 1,
                        }}
                      >
                        <Box>
                          <Typography
                            sx={{
                              color: color.masterDialogTitleColor,
                              fontSize: color.masterDialogFontSize,
                            }}
                            // sx={{
                            //   color: color.sideTitleColor,
                            //   fontSize: color.fontSizeSide,
                            //   fontWeight: color.sideWeightFont,
                            // }}
                          >
                            Document List
                          </Typography>
                          <Divider
                            sx={{
                              border: "1px solid rgb(0 0 0 / 17%)",
                              mt: "10px",
                            }}
                          />
                        </Box>

                        <NormalTable columns={columns} data={docData} />
                      </Paper>
                    </Box>
                  </TabPanel>
                </TabContext>
                <Grid
                  container
                  item
                  xs={12}
                  justifyContent={"flex-end"}
                  gap="1rem"
                >
                  <Button
                    onClick={handleCancel}
                    variant="contained"
                    sx={{
                      backgroundColor: color.TableCancelButton,
                      textTransform: "none",
                      color: color.CancelTextColor,
                      ":hover": {
                        backgroundColor: color.TableCancelButton,
                        textTransform: "none",
                        color: color.CancelTextColor,
                      },
                    }}
                  >
                    Cancel
                  </Button>
                  {approvalContext?.fromApproval ? (
                    <>
                      {approvalStatus === "Pending" ? (
                        <>
                          <Button
                            onClick={() => setShowRejectModal(true)}
                            variant="contained"
                            startIcon={<CloseIcon />}
                            sx={{
                              textTransform: "none",
                              backgroundColor: "#d32f2f",
                              "&:hover": {
                                backgroundColor: "#c62828",
                              },
                            }}
                          >
                            Reject
                          </Button>
                          <Button
                            onClick={handleApprove}
                            variant="contained"
                            startIcon={<Check />}
                            sx={{
                              textTransform: "none",
                              backgroundColor: "#2e7d32",
                              "&:hover": {
                                backgroundColor: "#1b5e20",
                              },
                            }}
                          >
                            Approve
                          </Button>
                        </>
                      ) : (
                        <Box>
                          <Typography
                            sx={{
                              fontWeight: 600,
                              color:
                                approvalStatus === "Approved"
                                  ? "#2e7d32"
                                  : "#d32f2f",
                              fontSize: "14px",
                            }}
                          >
                            Status: {approvalStatus}
                          </Typography>
                          {approvalLevel && (
                            <Typography
                              sx={{ fontSize: "13px", color: "#1976d2" }}
                            >
                              Workflow Level: {approvalLevel}
                            </Typography>
                          )}
                          {approvalStatus === "Rejected" &&
                            rejectedDescription && (
                              <Typography
                                sx={{ fontSize: "13px", color: "#d32f2f" }}
                              >
                                Rejection Reason: {rejectedDescription}
                              </Typography>
                            )}
                        </Box>
                      )}
                    </>
                  ) : (
                    <Button
                      type={"submit"}
                      variant="contained"
                      disabled={loading}
                      sx={{
                        textTransform: "none",
                        backgroundColor: loading
                          ? "default"
                          : color.TableButtonColor,
                        "&:hover": {
                          backgroundColor: loading
                            ? "default"
                            : color.buttonDisable,
                        },
                      }}
                    >
                      Submit
                    </Button>
                  )}
                </Grid>
              </Form>
            )}
          </Formik>
        </Box>
      )}
      <UnifiedModal
        open={showRejectModal}
        onClose={() => setShowRejectModal(false)}
        title="Reject Request"
        description="Please provide a reason for rejection:"
        inputLabel="Rejection Description"
        inputValue={rejectDescription}
        onInputChange={(e) => setRejectDescription(e.target.value)}
        onCancel={() => setShowRejectModal(false)}
        onReject={handleReject}
        rejectButtonColor="error"
        rejectButtonVariant="contained"
        minRows={2}
        autoFocus={true}
      />
    </>
  );
};

export default ServiceReqModal;
